import { createAction } from "@reduxjs/toolkit";

export const resetMarketAreaDrawing = createAction("marketAreaDrawing/reset");
